import { QuestionIds } from '../constants/QuestionIds';
import { PersonalizationSectionQuestionIds } from '../PersonalizationQuestionIds';

export const DefaultOnboradingQuestionsOrder: QuestionIds[] = [
  QuestionIds.AboutYouGuided,
  QuestionIds.AboutYouD1,
  QuestionIds.AboutYouGender,
  QuestionIds.AboutYouAge,
  QuestionIds.AboutYouRoutine,
  QuestionIds.AboutYouD2,
  QuestionIds.AboutYouKids,
  QuestionIds.AboutYouD3,
  QuestionIds.AboutYouActivity,
  QuestionIds.AboutYouD4,
  QuestionIds.AboutYouProof1,

  QuestionIds.SleepAndActivityQ1,
  QuestionIds.SleepAndActivityQ2,
  QuestionIds.SleepAndActivityD1,
  QuestionIds.SleepAndActivityQ3,
  QuestionIds.SleepAndActivityProof1,
  QuestionIds.SleepAndActivityProof2,
  QuestionIds.SleepAndActivityCoffee,
  QuestionIds.SleepAndActivityDinner,
  QuestionIds.SleepAndActivityAfterMidnight,
  QuestionIds.SleepAndActivityLessThanEightHours,
  QuestionIds.SleepAndActivityExtraMotivation,
  QuestionIds.SleepAndActivityD2,
  QuestionIds.SleepAndActivityLoader,

  QuestionIds.PersonalizationD1,
  ...PersonalizationSectionQuestionIds,
];
